import PillowSection from './PillowSection';

export default PillowSection;
